<template>
    <div class="modal-container">
        <div class="modal-header">
            <h4 class="modal-title">Cut off type</h4>
            <md-button class="md-simple md-just-icon md-round modal-default-button" @click.stop="$modal.hide">
                <md-icon>clear</md-icon>
            </md-button>
        </div>
        <div class="modal-body">
            <div class="md-layout">
                <div class="md-layout-item md-size-100 cutoff-time-type-container">
                    <form-group>
                        <vue-select
                            :reduce="(x) => x.id"
                            label="name"
                            :options="cutOffTypeOptions"
                            v-model="deliveryWindowTemp.cutOffType"
                            placeholder="Select cut off type"
                        ></vue-select>
                    </form-group>
                </div>
                <div
                    class="md-layout-item md-size-100 cutoff-time-before-window-container"
                    v-if="deliveryWindowTemp.cutOffType === 0"
                >
                    <form-group>
                        <md-input
                            v-model.number="deliveryWindowTemp.cutOffTimeBeforeSlotValue"
                            type="number"
                            placeholder="Value"
                        />
                    </form-group>
                    <form-group>
                        <vue-select
                            :reduce="(x) => x.id"
                            label="name"
                            :options="cutOffTimeBeforeSlotTypeOptions"
                            v-model="deliveryWindowTemp.cutOffTimeBeforeSlotType"
                            placeholder="Type"
                        ></vue-select>
                    </form-group>
                </div>
                <div
                    class="md-layout-item md-size-100 cutoff-by-time-container"
                    v-if="deliveryWindowTemp.cutOffType === 1"
                >
                    <form-group>
                        <md-icon>access_time</md-icon>
                        <time-picker
                            :time="deliveryWindowTemp.cutOffByTimeValue"
                            :all-time-options="false"
                            @selectedTime="
                                (selectedTime, isTimeValid) => {
                                    handleSetCutOffByTimeValue(selectedTime, isTimeValid, deliveryWindowTemp);
                                }
                            "
                        />
                    </form-group>
                    <form-group v-show="deliveryWindowTemp.cutOffByTimeType === 4">
                        <md-input
                            v-model.number="deliveryWindowTemp.cutOffByTimeNDaysPriorValue"
                            type="number"
                            placeholder="Days"
                        />
                    </form-group>
                    <form-group>
                        <vue-select
                            :reduce="(x) => x.id"
                            label="name"
                            :options="cutOffByTimeTypeOptions"
                            v-model="deliveryWindowTemp.cutOffByTimeType"
                            placeholder="Type"
                        ></vue-select>
                    </form-group>
                </div>
                <div
                    class="md-layout-item md-size-100 cut-off-label-container"
                    v-if="$_isValidServiceAreaCutOffCombination(deliveryWindowTemp, currentDayOfTheWeek)"
                >
                    {{ $_generateServiceAreaCutOffLabel(deliveryWindowTemp, currentDayOfTheWeek) }}
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <md-button
                class="md-primary dialog-button"
                @click="doneCutOffSetup(deliveryWindowTemp, currentDayOfTheWeek)"
            >
                Done
            </md-button>
        </div>
    </div>
</template>

<script>
import { TimePicker } from '@/components';
import { showErrorMessage } from '@/helpers';
import { GeneralMixin } from '@/mixins/GeneralMixin';

export default {
    name: 'ServiceAreasCutOffModal',
    components: {
        TimePicker
    },
    mixins: [GeneralMixin],
    props: {
        currentDayOfTheWeek: {
            type: Number,
            default: null
        },
        deliveryWindow: {
            type: Object,
            default: () => {}
        },
        resolve: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            cutOffTypeOptions: [
                {
                    id: 0,
                    name: 'Time before delivery window'
                },
                {
                    id: 1,
                    name: 'Cutoff by time'
                }
            ],
            cutOffTimeBeforeSlotTypeOptions: [
                {
                    id: 0,
                    name: 'Minutes'
                },
                {
                    id: 1,
                    name: 'Hours'
                },
                {
                    id: 2,
                    name: 'Days'
                }
            ],
            cutOffByTimeTypeOptions: [
                {
                    id: 0,
                    name: 'Same day'
                },
                {
                    id: 1,
                    name: '1 day prior'
                },
                {
                    id: 2,
                    name: '2 days prior'
                },
                {
                    id: 3,
                    name: '3 days prior'
                },
                {
                    id: 4,
                    name: 'N days prior'
                }
            ],
            deliveryWindowTemp: {
                cutOffType: null,
                cutOffTimeBeforeSlotValue: null,
                cutOffTimeBeforeSlotType: null,
                cutOffByTimeValue: null,
                cutOffByTimeNDaysPriorValue: null,
                cutOffByTimeType: null
            }
        };
    },
    async mounted() {
        this.deliveryWindowTemp = { ...this.deliveryWindow };
    },
    methods: {
        handleSetCutOffByTimeValue(selectedTime, isTimeValid, deliveryWindowTemp) {
            if (isTimeValid && selectedTime?.appointmentTime) {
                deliveryWindowTemp.cutOffByTimeValue = selectedTime.appointmentTime;
            }
        },
        async doneCutOffSetup(deliveryWindowTemp, currentDayOfTheWeek) {
            if (this.$_isValidServiceAreaCutOffCombination(deliveryWindowTemp, currentDayOfTheWeek)) {
                this.resolve(deliveryWindowTemp);
            } else {
                showErrorMessage(this, this.$_generateServiceAreaCutOffLabel(deliveryWindowTemp, currentDayOfTheWeek));
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.modal-container {
    width: 410px !important;
    max-width: 410px !important;
}

.modal-body {
    width: 410px !important;
    padding: 0 10px 10px 10px;
}

::v-deep .vs--searchable .vs__dropdown-toggle {
    border-bottom: 0 !important;
}

.cutoff-time-type-container {
    > div {
        margin-top: 0;
    }
}

.cutoff-time-type-container,
.cutoff-time-before-window-container,
.cutoff-by-time-container {
    ::placeholder {
        color: #aaa;
        opacity: 1;
    }
}
.cutoff-time-before-window-container {
    .md-field {
        display: inline-block;
    }
    .md-field:nth-child(1) {
        width: 70px;
        input {
            width: 70px;
            margin-bottom: 1px;
        }
    }
    .md-field:nth-child(2) {
        width: 125px;
    }
}

.cutoff-by-time-container {
    .md-field:nth-child(1) {
        width: 160px;
        padding-bottom: 12px;
        display: inline-flex;
        ::v-deep .vs__dropdown-toggle {
            margin-bottom: 1px !important;
        }
    }
    .md-field:nth-child(2) {
        width: 50px;
        display: inline-block;
        input {
            width: 50px;
            margin-bottom: 1px;
        }
    }
    .md-field:nth-child(3) {
        width: 150px;
        display: inline-block;
    }
}

.cut-off-label-container {
    font-size: small;
    margin-top: 10px;
}
</style>
